import { LoadingButton } from '@mui/lab';
import { ButtonProps } from '@mui/material';

interface StandardButtonProps extends Omit<ButtonProps, 'color'> {
  padding?: string;
  invertColor?: boolean;
  color?: string;
  backgroundColor?: string;
  border?: string;
  loading?: boolean;
}

function StandardButton(props: StandardButtonProps) {
  const {
    children,
    sx = {},
    startIcon,
    padding,
    onClick,
    invertColor,
    disabled,
    color,
    backgroundColor,
    border,
    loading = false
  } = props;

  const getColor = () => {
    let clr = '#ffffff';
    if (color) {
      clr = color;
    } else if (disabled) {
      clr = 'darkgray';
    } else if (invertColor) {
      clr = 'primary.main';
    }
    return clr;
  };

  const getBackgroundColor = () => {
    let bgColor = 'primary.main';
    if (backgroundColor) {
      bgColor = backgroundColor;
    } else if (disabled) {
      bgColor = '#eee';
    } else if (invertColor) {
      bgColor = '#fff';
    }
    return bgColor;
  };
  return (
    <LoadingButton
      loading={loading}
      startIcon={startIcon ?? null}
      sx={{
        typography: 'body1',
        color: getColor(),
        backgroundColor: getBackgroundColor(),
        '&:hover': {
          backgroundColor: getBackgroundColor()
        },
        padding: padding ?? '1.1rem 5rem',
        border: invertColor || border ? '1px solid' : 'none',
        borderColor: color ? color : 'primary.main',
        cursor: disabled ? 'not-allowed' : 'pointer',
        borderRadius: '.8rem',
        fontFamily: 'Source Sans 3',
        fontWeight: '600',
        ...sx
      }}
      onClick={(e) => {
        if (disabled) return;
        if (onClick) {
          onClick(e);
        }
      }}
      disableRipple={disabled}>
      {children}
    </LoadingButton>
  );
}

export default StandardButton;
